import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const createDataExport = createAsyncThunk(
    "createDataExport",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("/data-export/");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const fetchDataExportStatus = createAsyncThunk(
    "fetchDataExportStatus",
    async (exportId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/data-export/${exportId}/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const fetchLatestDataExport = createAsyncThunk(
    "fetchLatestDataExport",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("/data-export/");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const DataExportSlice = createSlice({
    name: "DataExport",
    initialState: {
        currentExport: null,
        creating: false,
        loading: false,
        error: null,
    },
    reducers: {
        clearDataExportError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // createDataExport action promises
        builder.addCase(createDataExport.pending, (state) => {
            state.creating = true;
            state.error = null;
        });
        builder.addCase(createDataExport.fulfilled, (state, action) => {
            state.creating = false;
            state.currentExport = action.payload;
        });
        builder.addCase(createDataExport.rejected, (state, action) => {
            state.creating = false;
            state.error = action.payload;
        });

        // fetchDataExportStatus action promises
        builder.addCase(fetchDataExportStatus.fulfilled, (state, action) => {
            state.currentExport = action.payload;
        });
        builder.addCase(fetchDataExportStatus.rejected, (state, action) => {
            state.error = action.payload;
        });

        // fetchLatestDataExport action promises
        builder.addCase(fetchLatestDataExport.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchLatestDataExport.fulfilled, (state, action) => {
            state.loading = false;
            state.currentExport = action.payload?.[0] || null;
        });
        builder.addCase(fetchLatestDataExport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { clearDataExportError } = DataExportSlice.actions;
export default DataExportSlice.reducer;
